<template>
  <widget-temp widgetTitle="Tiền đã ứng" widgetName="AdvancePayment" v-bind:widgetId="2">
    <template slot="widget-content">
      <div class="performance-block">
        <div class="row">
          <div class="col col-8">
            <div class="row">
              <div class="col">
                <div class="stt-block green-color">
                  <div class="div-table">
                    <div class="div-table-cell">
                      <p class="title-stt">Đã mua hàng</p>
                      <p class="num">{{ advancePayment.Detail.InBought | currency }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="stt-block green-color">
                  <div class="div-table">
                    <div class="div-table-cell">
                      <p class="title-stt">Đang vận chuyển</p>
                      <p class="num">{{ advancePayment.Detail.InTransit | currency }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="stt-block green-color">
                  <div class="div-table">
                    <div class="div-table-cell">
                      <p class="title-stt">Đã nhập kho</p>
                      <p class="num">{{ advancePayment.Detail.InStore | currency }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="stt-block green-color">
                  <div class="div-table">
                    <div class="div-table-cell">
                      <p class="title-stt">Chờ thanh toán</p>
                      <p class="num">{{ advancePayment.Detail.InPay | currency }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col col-4">
            <div class="stt-block yellow-bgcolor">
              <div class="div-table height-2">
                <div class="div-table-cell">
                  <p class="title-stt">Tổng tiền ứng</p>
                  <p class="num">{{ advancePayment.Total | currency }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </widget-temp>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import config from "@/configs";
export default {
  name: "advance-payment",
  computed: {
    ...mapState({
      advancePayment: state => state.dashboard.advancePayment
    })
  },
  methods: {
    getChartData() {
      this.$store.dispatch("dashboard/getAdvancePayment");
    }
  },
  mounted: function() {
    this.getChartData();
  }
};
</script>
<style scoped>
@media (max-width: 686px) {
    .widget-block .content-widget .performance-block .title-stt {
        font-size: 14px;
        line-height: 1.2; }
    .widget-block .content-widget .performance-block .num {
        font-size: 28px; } }
    @media (max-width: 500px) {
    .widget-block .content-widget .performance-block .col.col-4, .widget-block .content-widget .performance-block .col.col-8 {
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%; }
    .widget-block .content-widget .performance-block .div-table.height-2 {
        height: 150px !important; } }
.widget-block .content-widget .stt-block{margin-bottom:10px;}
.performance-block .col > .col{padding: 0;}
.performance-block .col > .col > .col{padding: 0;}
.performance-block .row{margin: 0px;}
.performance-block .col{padding:0px;}
</style>